import { useFetch } from '@/hooks/useFetch';
import type { AddFileRequest, AddFileResponse } from '@/types/documentsApiTypes';
import { useMutation } from '@tanstack/react-query';

export const useAddFile = () => {
  const { doFetch } = useFetch<AddFileRequest, AddFileResponse>();

  return useMutation({
    mutationFn: async (options: AddFileRequest) => {
      return doFetch('/api/documents', {
        method: 'POST',
        body: options,
      });
    },
  });
};